import { CheckIcon, ClockIcon } from "./ui";

export type ProgressState = "done" | "cur" | "wait" | "todo";

/**
 * "Details · Email · Number": where a person is within step 1 of sign-up. The third part is
 * "Approval" when there's no phone to confirm (a UEN) and goes amber when a person is checking.
 */
export function SignupProgress({
  states,
  third = "Number",
}: {
  states: [ProgressState, ProgressState, ProgressState];
  third?: "Number" | "Approval";
}) {
  const labels = ["Details", "Email", third];
  return (
    <ol className="su-prog" aria-label="Sign-up progress">
      {labels.map((label, i) => (
        <li key={label} style={{ display: "contents" }}>
          {i > 0 && <span className="su-psep" aria-hidden="true" />}
          <span className={`su-pi su-pi--${states[i]}`} aria-current={states[i] === "cur" ? "step" : undefined}>
            <span className="su-pdot">
              {states[i] === "done" ? (
                <CheckIcon size={12} strokeWidth={3} />
              ) : states[i] === "wait" ? (
                <ClockIcon size={13} strokeWidth={2.6} />
              ) : (
                i + 1
              )}
            </span>
            {label}
          </span>
        </li>
      ))}
    </ol>
  );
}
